import { i18n } from "./../i18n";
import { createApp } from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Toast from "vue-toastification";
import toastConfig from "./../toast";
import store from "./../client/store";

import "./../vee-validate";

const app = createApp();

app.use(store);
app.use(VueSweetalert2);
app.use(Toast, toastConfig);
app.use(i18n);

app.component(
  "cart-index",
  require("./../client/views/cart/Index.vue").default
);

app.mount("#app");
